// @flow
import routerActions from '../../actions/router';
import cookieUtils from '../../utils/cookieUtils';
import {LOCATION_COOKIE} from '../../utils/locationData';

import type {Action} from '../../actions/redirect';

/* TODO: remove this cookie when we consolidate. See SERP-837 */
export default function redirect(store: Object, action: Action) {
    /* read the ha-state-prst cookie */
    const haStatePersistCookie = cookieUtils.readCookie(LOCATION_COOKIE);
    /* add / override the lbsKeywords */
    haStatePersistCookie.lbsKeywords = null;
    /* write the new ha-state-prst cookie for PDP / Homepage */
    cookieUtils.writeCookie(LOCATION_COOKIE, haStatePersistCookie);
    /* write history state to world search before redirect to avoid infinite loop */
    store.dispatch(routerActions.keywords(''));
    /* redirect */
    /* istanbul ignore next */
    if (typeof window !== 'undefined') {
        window.location.href = action.payload.url;
    }
}
